<script lang="ts">
    import LayersComponent from "./Layers.svelte";
    import { appManager } from "../../AppManager";
    import {_} from "svelte-i18n"
    import Vehicles from "./Vehicles.svelte";
    import { ModalHook } from "../../shared/modals/ModalHook";
    import { TripsModalManager } from "./TripsModalManager";
    import type { MapView } from "../../lib/maps/MapView";
    import type { MatrixNewData } from "../../api/projects/data/matrix/MatrixNewData";
    
    appManager.ModalHooks.TripsModal = new ModalHook<MapView, MatrixNewData>();

    let manager = new TripsModalManager(appManager.ModalHooks.TripsModal);
    let open = manager.getOpenStore();
    let layersManager = manager.getLayersManager();
    let canSave = manager.getCanSaveStore();
    let mapContainer = manager.getMapContainerStore();

    const save = () => {
        manager.save();
    }
    const close = () => {
        manager.close();
    };
</script>

{#if $open}
    <div class="modal show" style="display: block;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title h4">
                        {$_("impact.scenario.tipsMatrixModal.title")}
                    </div>
                    <button
                        type="button"
                        class="btn-close btn-lg btn-close-lg"
                        aria-label="Close"
                        on:click={close} />
                </div>
                <div class="modal-body p-0">
                    <div class="container-fluid p-0 h-100">
                        <div class="row g-0 h-100">
                            <div class="col-4 p-2">
                                <div class="box bg-light">
                                    <div class="box-header">
                                        <div class="row mx-0 mb-2">
                                            <div class="col-6 ps-0 pe-1">
                                                <Vehicles manager={manager.getVehiclesManager()} />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="box-content">
                                        <LayersComponent manager={layersManager}/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="map w-100 h-100">
                                    <div
                                        class="w-100 h-100"
                                        bind:this={$mapContainer}>
                                        <slot />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary {$canSave ? '' : 'disabled'}"
                        data-bs-dismiss="modal"
                        on:click={save}> {$_("impact.scenario.tipsMatrixModal.save")}</button>
                </div>
            </div>
        </div>
    </div>
{/if}

<style>
    .map {
        border-radius: 0.5rem;
        position: relative;
        bottom: 0px;
        left: 0px;
        right: 0px;
    }

    .modal {
        display: block;
    }

    .modal-footer {
        padding: 1rem;
    }

    .modal-header {
        padding: 1rem;
    }
</style>
